import promotions from './promotions'
import envelope from './envelope'
import coupon from './coupon'
export default {
	promotions,
	envelope,
	coupon
}



// WEBPACK FOOTER //
// ./src/store/mp/marketing/index.js